// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.number.epsilon.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.number.epsilon.js
// module chunks = 0